import React, { useEffect } from "react";
import { Container, Row, Col, InputGroup, Button, Card, CardBody, Label } from "reactstrap";
import CustomInput from "../../../custom/CustomInput";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import CircularIndeterminate from "../../loader/CircularIndeterminate";
import Branch2025 from "../../../assets/Branch2025.pdf";
import { useSafariPaymentReset } from "../../../hooks/useSafariPaymentReset";

// Temporary mock for actions to avoid 'actions is not defined' error
const actions = {
  postCourseregData: (data, setSubmitting, resetForm, url) => {
    console.log("Mock postCourseregData", { data, url });
    setSubmitting(false);
    resetForm();
  },
};

const ProfessionalCourses = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);

  useEffect(() => {
    // Placeholder for dispatch actions if needed
  }, []);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const coursereg = {
      clientname: values.clientname,
      age: values.age,
      qualification: values.qualification,
      clientphone: values.clientphone,
      clientemail: values.clientemail,
      parent_name: values.parent_name,
      parent_phone: values.parent_phone,
      parent_email: values.parent_email,
      aadhar_card: values.aadhar_card,
      pan_card: values.pan_card,
      totalfees: values.totalfees,
    };
    // Direct backend redirect - iOS compatible
    dispatch(
      actions.postCourseregDataWithBackendRedirect(coursereg, setSubmitting, resetForm)
    );
    setSubmitting(true);
  };

  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  age: "",
                  qualification: "",
                  clientphone: "",
                  clientemail: "",
                  parent_name: "",
                  parent_phone: "",
                  parent_email: "",
                  aadhar_card: null,
                  pan_card: null,
                  totalfees: "1000", // Placeholder value
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientname: Yup.string().required("Name is required"),
                  age: Yup.number().required("Age is required").positive().integer(),
                  qualification: Yup.string().required("Qualification is required"),
                  clientphone: Yup.string().required("Contact Number is required"),
                  clientemail: Yup.string()
                    .email("Invalid Email address")
                    .required("Email is required"),
                  parent_name: Yup.string().when("age", {
                    is: (age) => age < 18,
                    then: Yup.string().required("Parent/Guardian Name is required for minors"),
                  }),
                  parent_phone: Yup.string().when("age", {
                    is: (age) => age < 18,
                    then: Yup.string().required("Parent/Guardian Contact Number is required for minors"),
                  }),
                  parent_email: Yup.string().when("age", {
                    is: (age) => age < 18,
                    then: Yup.string().email("Invalid Email address").required("Parent/Guardian Email is required for minors"),
                  }),
                  aadhar_card: Yup.mixed().required("Aadhar Card is required"),
                  pan_card: Yup.mixed().required("PAN Card is required"),
                })}
              >
                {(formProps) => (
                  <Form className="mt-3">
                    <Row className="form-group">
                      <Col md={6} className="mt-2">
                        <Label htmlFor="clientname" className="label">
                          Name:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientname"
                            id="clientname"
                            placeholder="Enter Your Name"
                            className={
                              "form-control" +
                              (formProps.errors.clientname && formProps.touched.clientname
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientname"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Label htmlFor="age" className="label">
                          Age:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="number"
                            name="age"
                            id="age"
                            placeholder="Enter Your Age"
                            className={
                              "form-control" +
                              (formProps.errors.age && formProps.touched.age
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="age"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={6} className="mt-2">
                        <Label htmlFor="qualification" className="label">
                          Qualification:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="qualification"
                            id="qualification"
                            placeholder="Enter Your Qualification"
                            className={
                              "form-control" +
                              (formProps.errors.qualification && formProps.touched.qualification
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="qualification"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Label htmlFor="clientphone" className="label">
                          Contact Number:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientphone"
                            id="clientphone"
                            placeholder="Enter Your Contact Number"
                            className={
                              "form-control" +
                              (formProps.errors.clientphone && formProps.touched.clientphone
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientphone"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={6} className="mt-2">
                        <Label htmlFor="clientemail" className="label">
                          Email ID:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="email"
                            name="clientemail"
                            id="clientemail"
                            placeholder="Enter Your Email"
                            className={
                              "form-control" +
                              (formProps.errors.clientemail && formProps.touched.clientemail
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientemail"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Label htmlFor="parent_name" className="label">
                          Name of Parent/Guardian (If under 18):
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="parent_name"
                            id="parent_name"
                            placeholder="Enter Parent/Guardian Name"
                            className={
                              "form-control" +
                              (formProps.errors.parent_name && formProps.touched.parent_name
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="parent_name"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={6} className="mt-2">
                        <Label htmlFor="parent_phone" className="label">
                          Contact Number of Parent/Guardian:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="parent_phone"
                            id="parent_phone"
                            placeholder="Enter Parent/Guardian Contact Number"
                            className={
                              "form-control" +
                              (formProps.errors.parent_phone && formProps.touched.parent_phone
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="parent_phone"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Label htmlFor="parent_email" className="label">
                          Email ID of Parent/Guardian:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="email"
                            name="parent_email"
                            id="parent_email"
                            placeholder="Enter Parent/Guardian Email"
                            className={
                              "form-control" +
                              (formProps.errors.parent_email && formProps.touched.parent_email
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="parent_email"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={6} className="mt-2">
                        <Label htmlFor="aadhar_card" className="label">
                          Upload Student's Aadhar Card:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="file"
                            name="aadhar_card"
                            id="aadhar_card"
                            accept=".pdf,.jpg,.jpeg,.png"
                            className={
                              "form-control" +
                              (formProps.errors.aadhar_card && formProps.touched.aadhar_card
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="aadhar_card"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Label htmlFor="pan_card" className="label">
                          Upload Student's PAN Card:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="file"
                            name="pan_card"
                            id="pan_card"
                            accept=".pdf,.jpg,.jpeg,.png"
                            className={
                              "form-control" +
                              (formProps.errors.pan_card && formProps.touched.pan_card
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="pan_card"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={6}>
                        <InputGroup>
                          <Field type="checkbox" name="checked" value="One" />
                          <span className="radiobtn-test">
                            {" "}
                            &nbsp;
                            <a href={Branch2025} target="_blank">
                              Please Accept Terms & Condition
                            </a>
                          </span>
                          <ErrorMessage
                            name="checked"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <div className="mt-3 mb-3 row">
                      <div className="col-12">
                        <Button
                          type="submit"
                          className="register-btn"
                          size="md"
                          block
                        >
                          {isPostLoading ? (
                            <CircularIndeterminate />
                          ) : (
                            "PAY NOW"
                          )}
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default ProfessionalCourses;